export const MAIN_CHART_STORAGE_KEYS = {
  CORE: 'mt6_main_chart_core'
} as const;